import { getData } from '../../constants/api_index';

class programService {
  getProgram() {
    return getData('program/all');
  }
}

export default new programService();
